import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../../API";

export const getManualPriceProductGroupAction = createAsyncThunk(
  "ManualPriceProductGroup/GetAllManualPriceProductGroup",
  async (data) => {
    return apiCall("manualpriceproductgroup?approved=" + data.approved, "POST", data, false)
      .then((response) => {
        if (response.status === 200) {
          if (!response.data.hasError) {

            return {
              ...response.data,
            }
          } else {
            console.log("response error", response.data.message);
            return Promise.reject({
              ...response.data.message,
            });
          }
        }
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
        });
      });
  }
);

export const insertUpdateManualPriceProductGroupAction = createAsyncThunk(
  "ManualPriceProductGroup/insertupdateManualPriceProductGroup",
  async (data) => {
    return apiCall("manualpriceproductgroup/add", "POST", data, false)
      .then((response) => {
        console.log("api response", response);
        if (response.status === 200) {
          if (!response.data.hasError) {
            // console.log('response.data ',response.data.message)
            let message = response.data.message
            // console.log("message",message);
            return {
              data: {
                ...response.data,
              },
              message: {
                code: response.data.message.code,
                type: response.data.message.type,
                message: response.data.message.message
              },
              newRecord: data.id ? false : true
            }
          } else {
            // console.log("response error", response.data.message);
            if (!response.data.message && response.data.errors && response.data.errors.length) {
              response.data.message = response.data.errors[0];
            }
            return Promise.reject({
              ...response.data.message,
            });
          }
        }
        else {
          return Promise.reject({
            ...response.data,
          });
        }
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
        });
      });
  }
);


export const getManualGroupAction = createAsyncThunk(
  "ManualPriceProductGroup/GetManualGroup",
  async (data) => {
    return apiCall("manualpriceproductgroup/getgroup", "POST", data, false)
      .then((response) => {
        if (response.status === 200) {
          if (!response.data.hasError) {
            return {
              ...response.data,
            }
          } else {
            return Promise.reject({
              ...response.data.message,
            });
          }
        }
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
        });
      });
  }
);

export const activeInactiveAction = createAsyncThunk(
  'ManualPriceProductGroup/activeinactive',
  async (data) => {
    return apiCall("manualpriceproductgroup/activeinactive", "POST", data, false)
      .then((response) => {
        if (response.status === 200) {
          if (!response.data.hasError) {
            return {
              ...response.data,
            }
          } else {
            return Promise.reject({
              ...response.data.message,
            });
          }
        }
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
        });
      });
  }
)

export const getProductGroupComparisonAction = createAsyncThunk(
  "ManualPriceProductGroup/GetProductComparison",
  async (data) => {
    return apiCall("manualpriceproductgroup/getgroupcomparison?id=" + data.id, "POST", null, false)
      .then((response) => {
        if (response.status === 200) {
          if (!response.data.hasError) {
            return {
              ...response.data,
            }
          } else {
            return Promise.reject({
              ...response.data.message,
            });
          }
        }
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
        });
      });
  }
);

export const manualPriceProductGroupApproveAction = createAsyncThunk(
  "ManualPriceProductGroup/Approve",
  async (data) => {
    return apiCall("manualpriceproductgroup/approve?id=" + data.id, "POST", null, false)
      .then((response) => {
        if (response.status === 200) {
          if (!response.data.hasError) {
            return {
              ...response.data,
            }
          } else {
            return Promise.reject({
              ...response.data.message,
            });
          }
        }
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
        });
      });
  }
);

export const manualPriceProductGroupRejectAction = createAsyncThunk(
  "ManualPriceProductGroup/Reject",
  async (data) => {
    return apiCall("manualpriceproductgroup/reject?id=" + data.id, "POST", null, false)
      .then((response) => {
        if (response.status === 200) {
          if (!response.data.hasError) {
            return {
              ...response.data,
            }
          } else {
            return Promise.reject({
              ...response.data.message,
            });
          }
        }
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
        });
      });
  }
);